export enum VideoType {
  video = 'video',
  screen = 'screen',
}
